export type FlightSegment = {
  id: number;
  type: string;
  reference?: string | null;
  dateDeparture: string;
  dateArrival: string;
  dateDepartureHidden: boolean | null;
  dateArrivalHidden: boolean | null;
  airportFrom: { title: string; code: string };
  airportTo: { title: string; code: string };
};

const schedule = (value: string, hidden: boolean | null) =>
  value.slice(0, 10).split("-").reverse().join("/") + (hidden ? "" : ` - ${value.slice(11, 16)}`);

export function FlightSegments({ segments }: { segments: FlightSegment[] }) {
  if (!segments.length) return null;
  return (
    <div className="overflow-x-auto rounded border border-[#C1B1AC]">
      <table className="w-full border-collapse text-left text-sm text-primary">
        <thead className="bg-[#F0E9E1] uppercase">
          <tr>
            {["Départ", "Arrivée", "Vols"].map((label) => (
              <th key={label} scope="col" className="border-b border-r border-[#C1B1AC] px-3 py-2 last:border-r-0">
                {label}
              </th>
            ))}
          </tr>
        </thead>
        {(["depart", "return"] as const).map((direction) => {
          const legs = segments.filter((segment) => segment.type === direction);
          if (!legs.length) return null;
          return (
            <tbody key={direction}>
              <tr>
                <th
                  colSpan={3}
                  scope="rowgroup"
                  className="border-b border-[#F0E9E1] bg-[#F9F4EE] px-3 py-1 font-medium text-[#6D6662]"
                >
                  {direction === "depart" ? "Aller" : "Retour"}
                </th>
              </tr>
              {legs.map((leg) => (
                <tr key={leg.id} className="border-b border-[#F0E9E1] bg-white last:border-b-0">
                  {(
                    [
                      [leg.airportFrom, leg.dateDeparture, leg.dateDepartureHidden],
                      [leg.airportTo, leg.dateArrival, leg.dateArrivalHidden],
                    ] as const
                  ).map(([airport, date, hidden], index) => (
                    <td key={index} className="border-r border-[#F0E9E1] px-3 py-2">
                      <div>
                        <span className="font-semibold">{airport.title}</span> {airport.code}
                      </div>
                      <div className="text-[#6D6662]">{schedule(date, hidden)}</div>
                    </td>
                  ))}
                  <td className="whitespace-nowrap px-3 py-2">{leg.reference || "—"}</td>
                </tr>
              ))}
            </tbody>
          );
        })}
      </table>
    </div>
  );
}
